import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, Grid, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { observer } from 'mobx-react';
import { blackColor, whiteColor, redditColor } from '../../../assets/jss/nextjs-material-kit-pro';

const formStyles = makeStyles({
  form: {
    paddingLeft: 20,
    paddingTop: 20,
    width: '100%',
  },
  searchIcon: {
    top: 10,
    right: 33,
  },
  dialog: {
    width: 500,
    minHeight: 150,
    backgroundColor: whiteColor,
    color: blackColor,
    fontSize: '1.00rem',
  },
  dialogHeaderFooter: {
    backgroundColor: redditColor,
    color: whiteColor,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  search: {
    paddingBottom: 10,
  },
  button: {
    marginLeft: 20,
    marginBottom: 20,
  },
  actions: {
    '& .MuiDialogActions-spacing': {
      justifyContent: 'space-around',
    },
  },
  rowSpacer: {
    height: '30px',
  },
  buttonWidth: {
    width: '110px',
  },
});

const LifeSkillsDialog = observer((props) => {
  const { showLifeSkills, handleClose } = props;

  const formClasses = formStyles();

  return (
    <React.Fragment>
      <Dialog open={showLifeSkills} onClose={handleClose} scroll="paper" fullWidth maxWidth="md" aria-labelledby="Pop-up Help">
        <React.Fragment>
          <DialogTitle id="basic-info-dialog" className={formClasses.dialogHeaderFooter}>
            Advanced Life Skills Schedule 2026-2027
          </DialogTitle>
          <DialogContent
            className={formClasses.dialog}
            style={{
              minHeight: '350px',
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Box sx={{ width: '100%' }}>
              <Grid container direction="row" align="left" style={{ margin: '5px 0' }}>
                <Grid item xs={4} sm={3} md={2}>
                  Class #1
                </Grid>
                <Grid item xs={4} sm={3} md={3}>
                  Wednesday, August 26th
                </Grid>
                <Grid item xs={4} sm={3} md={7}>
                  6:30pm to 8:30pm
                </Grid>
              </Grid>
              <Grid container direction="row" align="left" style={{ margin: '5px 0' }}>
                <Grid item xs={4} sm={3} md={2}>
                  Class #2
                </Grid>
                <Grid item xs={4} sm={3} md={3}>
                  Wednesday, September 16th
                </Grid>
                <Grid item xs={4} sm={3} md={7}>
                  6:30pm to 8:30pm
                </Grid>
              </Grid>
              <Grid container direction="row" align="left" style={{ margin: '5px 0' }}>
                <Grid item xs={4} sm={3} md={2}>
                  Class #3
                </Grid>
                <Grid item xs={4} sm={3} md={3}>
                  Thursday, October 15th
                </Grid>
                <Grid item xs={4} sm={6} md={7}>
                  9:00am-11:00am
                </Grid>
              </Grid>
              <Grid container direction="row" align="left" style={{ margin: '5px 0' }}>
                <Grid item xs={4} sm={3} md={2}>
                  Class #4
                </Grid>
                <Grid item xs={4} sm={3} md={3}>
                  Thursday, November 12th
                </Grid>
                <Grid item xs={4} sm={3} md={7}>
                  9:00am-11:00am
                </Grid>
              </Grid>
              <Grid container direction="row" align="left" style={{ margin: '5px 0' }}>
                <Grid item xs={4} sm={3} md={2}>
                  Class #5
                </Grid>
                <Grid item xs={4} sm={3} md={3}>
                  Wednesday, December 2nd
                </Grid>
                <Grid item xs={4} sm={3} md={7}>
                  6:30pm to 8:30pm
                </Grid>
              </Grid>
              <Grid container direction="row" align="left" style={{ margin: '5px 0' }}>
                <Grid item xs={4} sm={3} md={2}>
                  Class #6
                </Grid>
                <Grid item xs={4} sm={3} md={3}>
                  Wednesday, January 20th
                </Grid>
                <Grid item xs={4} sm={3} md={7}>
                  6:30pm to 8:30pm
                </Grid>
              </Grid>
              <Grid container direction="row" align="left" style={{ margin: '5px 0' }}>
                <Grid item xs={4} sm={3} md={2}>
                  Class #7
                </Grid>
                <Grid item xs={4} sm={3} md={3}>
                  Wednesday, February 17th
                </Grid>
                <Grid item xs={4} sm={3} md={7}>
                  6:30pm to 8:30pm
                </Grid>
              </Grid>
              <Grid container direction="row" align="left" style={{ margin: '5px 0' }}>
                <Grid item xs={4} sm={3} md={2}>
                  Class #8
                </Grid>
                <Grid item xs={4} sm={3} md={3}>
                  Wednesday, March 10th
                </Grid>
                <Grid item xs={4} sm={3} md={7}>
                  6:30pm to 8:30pm
                </Grid>
              </Grid>
              <Grid container direction="row" align="left" style={{ margin: '5px 0' }}>
                <Grid item xs={4} sm={3} md={2}>
                  Class #9
                </Grid>
                <Grid item xs={4} sm={3} md={3}>
                  Wednesday, April 14th
                </Grid>
                <Grid item xs={4} sm={3} md={7}>
                  6:30pm to 8:30pm
                </Grid>
              </Grid>
            </Box>
          </DialogContent>
        </React.Fragment>
        <DialogActions className={formClasses.dialogHeaderFooter}>
          <Button
            backgroundColor="gray"
            variant="contained"
            className={formClasses.buttonWidth}
            onClick={handleClose}
            aria-describedby="close dialog"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
});

export default LifeSkillsDialog;

LifeSkillsDialog.propTypes = {
  showLifeSkills: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
